import { useWorkspace } from "../Stores/Workspaces";
import { useConversation } from "../Stores/Conversation";
import { createLocationAnimation } from "../Helpers/LocationAnimation";
export class EntityNavigator {
    /**
     * Get the workspace store instance
     * @returns {Object} Workspace store instance
     */
    static getWorkspaceStore() {
        return useWorkspace();
    }

    static getLocateAnimation() {
        return createLocationAnimation();
    }

    /**
     * Navigate to the appropriate entity based on its type
     * @param {Object} entityData - Entity data from API
     * @returns {Promise<void>}
     */
    static async navigateToEntity(entityData) {
        const { entity_type, entity_id, entity_data, ...parentIds } =
            entityData;

        switch (entity_type) {
            case "Item":
                return this.navigateToItem(entity_data, parentIds);
            case "ItemCategory":
                return this.navigateToItemCategory(entity_id, parentIds);
            case "Board":
                return this.navigateToBoard(entity_id, parentIds);
            case "BoardCategory":
                return this.navigateToBoardCategory(entity_id, parentIds);
            case "Workspace":
                return this.navigateToWorkspace(entity_id);
            case "WorkspaceCategory":
                return this.navigateToWorkspaceCategory(entity_id);
            case "Group":
            case "Topic":
                return this.navigateToConversation(entity_data, parentIds);
            default:
                throw new Error(`Unsupported entity type: ${entity_type}`);
        }
    }

    /**
     * Navigate to an Item
     * @param {number} itemId - Item ID
     */
    static async navigateToItem(itemData, parentIds) {
        return await this.getLocateAnimation().navigateToEntity("item", {
            itemId: itemData.id,
            spaceId: parentIds.workspace_id,
            boardId: parentIds.board_id,
            itemData,
        });
    }

    /**
     * Navigate to an ItemCategory (Item Group)
     * @param {number} itemCategoryId - Item Category ID
     * @param {Object} parentIds - Parent IDs for context
     */
    static async navigateToItemCategory(itemCategoryId, parentIds) {
        // First navigate to the board containing this item category
        await this.getLocateAnimation().navigateToEntity("item-group", {
            groupId: itemCategoryId,
            boardId: parentIds.board_id,
            spaceId: parentIds.workspace_id,
            groupData: null,
        });

        // TODO: Add logic to scroll to the specific item category
        // This might require additional store methods or DOM manipulation
    }

    /**
     * Navigate to a Board
     * @param {number} boardId - Board ID
     * @param {Object} parentIds - Parent IDs for context
     */
    static async navigateToBoard(boardId, parentIds) {
        // Set the workspace first if we have the workspace ID
        if (!parentIds.workspace_id || !boardId) {
            return alert("Invalid Board");
        }
        await this.getLocateAnimation().navigateToEntity("board", {
            boardId: boardId,
            spaceId: parentIds.workspace_id,
            boardData: null,
        });
        /* const workspaceStore = this.getWorkspaceStore();


        // Find and set the workspace
        const workspace = workspaceStore.getSpaceById(parentIds.workspace_id);

        if (!workspace?.id) {
            return console.log("invalid Workspace/you don't have permission to access");
        }

        await workspaceStore.loadBoards(workspace);
        workspaceStore.setActiveWorkspace(workspace);

        const board = workspaceStore.getBoardByBoardId(boardId, workspace)
        setTimeout(() => workspaceStore.setActiveBoard(board), 1000 ); */
    }

    /**
     * Navigate to a BoardCategory (Board Group)
     * @param {number} boardCategoryId - Board Category ID
     * @param {Object} parentIds - Parent IDs for context
     */
    static async navigateToBoardCategory(boardCategoryId, parentIds) {
        await this.getLocateAnimation().navigateToEntity("board-group", {
            groupId: boardCategoryId,
            spaceId: parentIds.workspace_id,
            groupData: null,
        });
        // First navigate to the workspace containing this board category
        /*         const workspace =   await this.navigateToWorkspace(parentIds.workspace_id);

        const boardGroup = this.getWorkspaceStore().getBoardGroupByBoardGroupId(boardCategoryId, workspace) */
    }

    /**
     * Navigate to a Workspace (Space)
     * @param {number} workspaceId - Workspace ID
     */
    static async navigateToWorkspace(workspaceId) {
        await this.getLocateAnimation().navigateToEntity("space", {
            spaceId: workspaceId,
            spaceData: null,
        });
        /* const workspaceStore = this.getWorkspaceStore();
        const workspace = workspaceStore.getSpaceById(workspaceId)

        if (workspace) {
            workspaceStore.setActiveWorkspace(workspace);
        }
        return workspace; */
    }

    /**
     * Navigate to a WorkspaceCategory (Space Group)
     * @param {number} workspaceCategoryId - Workspace Category ID
     */
    static async navigateToWorkspaceCategory(workspaceCategoryId) {
        await this.getLocateAnimation().navigateToEntity("space-group", {
            groupId: workspaceCategoryId,
            groupData: null,
        });
        /* const workspaceStore = this.getWorkspaceStore();

        workspaceStore.setActivePanel("spaces") */
    }

    /**
     * Navigate to a Conversation (Group or Topic)
     * @param {number} conversationId - Conversation ID
     * @param {Object} parentIds - Parent IDs for context (unused for now)
     */
    static async navigateToConversation(entityData, parentIds) {
        const conversationStore = useConversation();

        // Simply open the conversation by ID
        await conversationStore.openConversationById(
            entityData?.conversation_id,
        );
    }
}
